import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme =>({
  wrapper: {
    position: 'relative',
    display: 'flex',
    padding: '18px 40px 0',
    margin: '-18px 0 0',
    height: 'calc(100% - 125px)',
    overflowY: 'auto',
    overflowX: 'hidden',
    ['@media (max-width:1010px)']: {
      padding: '18px 0 0 40px',
      height: 'calc(100% - 125px)'
    },
    ['@media (max-width:850px)']: {
      padding: '0 0 0 40px',
      margin: '0px',
      height: 'calc(100% - 64px)'
    },
    ['@media (max-width:600px)']: {
      padding: '0 0 0 15px',
      height: 'calc(100% - 102px)'
    }
  },
  leftSide: {
    width: '618px',
    padding: '0 54px 0 1px',
    ['@media (max-width:1010px)']: {
      width: '100%',
      padding: '18px 40px 0 1px'
    },
    ['@media (max-width:850px)']: {
      marginTop: 0
    },
    ['@media (max-width:600px)']: {
      paddingRight: '15px',
      marginTop: 0
    }
  },
  rightSide: {
    width: '300px',
    minWidth: '300px',
    ['@media (max-width:1010px)']: {
      display: 'none'
    }
  },
  dateRange: {
    margin: '15px 0',
    width: '561px',
    ['@media (max-width:1010px)']: {
      margin: '0 0 15px'
    },
    ['@media (max-width:700px)']: {
      width: '292px'
    },
    ['@media (max-width:600px)']: {
      width: '332px'
    }
  },
  participant: {
    minWidth: '227px',
    ['@media (max-width:600px)']: {
      minWidth: '100%'
    }
  },
  disableInputFocus: {
    display: 'none'
  },
  sectionTitleIndent: {
    marginBottom: '20px'
  },
  startTimeLabel: {
    fontSize: '13px',
    lineHeight: '18px',
    fontWeight: 'bold',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    marginBottom: '0'
  },
  startTimeClass: {
    fontSize: '13px'
  },
  startTimeWrapper: {
    margin: '25px 0'
  },
  label: {
    textTransform: 'uppercase',
    letterSpacing: '0.05em'
  },
  loaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  loaderClassName: {
    width: `80px !important`,
    height: `80px !important`,
  },
  timePickerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '24px',
    '&:last-child': {
      marginBottom: 0,
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      marginBottom: '16px',
      padding: '0px 20px '
    },
  },
  timeInput: {
    width: '190px',
    [theme.breakpoints.down('sm')]:{
     width: '90%',
     padding: '20px 20px'
    }
  },
}));

export default useStyles;
